import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Typography,
  FormHelperText,
} from "@mui/material"
import useInput from "hooks/use_input"
import useTranslation from "hooks/use_translation"

const HighCholesterol = () => {
  const id = "cholesterol"
  const { fields } = useTranslation()

  const validate = (value) => {
    if (value === "") return "This field is required"

    return ""
  }

  const { handleChange, inputValue, errorMessage, handleBlur } = useInput(id, validate)

  return (
    <FormControl error={errorMessage?.length > 0}>
      <FormLabel id={id}>
        <Typography variant="body2" sx={{ fontWeight: 500, color: "black" }}>
          {fields?.cholesterol_title}
        </Typography>
      </FormLabel>
      <RadioGroup
        row
        value={inputValue}
        onChange={handleChange}
        onBlur={handleBlur}
        onTouchEnd={handleBlur}
      >
        <FormControlLabel value="yes" control={<Radio />} label={fields?.yes} />
        <FormControlLabel value="no" control={<Radio />} label={fields?.no} />
        <FormControlLabel value="no_sure" control={<Radio />} label={fields?.no_shure} />
      </RadioGroup>
      <FormHelperText sx={{ mt: -0.5, mb: 2 }}>{errorMessage}</FormHelperText>
    </FormControl>
  )
}

export default HighCholesterol
